/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, observable, makeObservable } from 'mobx';
import { ProductType } from '@veeam-vspc/models/web-controllers';

export class ConsumedPointsStore {

    @observable productType: ProductType;

    constructor(type: ProductType, readonly lsStateId: string) {
        makeObservable(this);
        this.productType = type;
    }

    @action.bound
    setProductType(v: ProductType): void {
        this.productType = v;
    }
}
